import React, { useState, useEffect } from 'react';
import {
  Box, Paper, Grid, Card, CardContent, Typography, List, ListItem, ListItemButton,
  ListItemText, Drawer, IconButton, CircularProgress, Button, Modal
} from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from '../Axiosinstance';
import Header from './Headstu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePowerpoint } from '@fortawesome/free-solid-svg-icons';

const extractYouTubeVideoId = (url) => {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/.*[?&]v=)([^&]+)/);
  return match ? match[1] : null;
};

const Key = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [curriculumData, setCurriculumData] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    axios.get('uploadcurriculums')
      .then((response) => {
        setCurriculumData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        setLoading(false);
      });
  }, []);

  const filteredData = curriculumData.filter((curriculum) => curriculum.course_id === parseInt(id, 10));

  const displayContent = (content) => {
    setSelectedContent(content);
    setModalOpen(true);
  };

  const renderContent = () => {
    if (!selectedContent) {
      return <Typography variant="h6" sx={{ textAlign: "center", mt: 2 }}>Select a course section</Typography>;
    }

    switch (selectedContent.type) {
      case "pdf":
        return <iframe src={`${selectedContent.fileUrl}#toolbar=0`} width="100%" height="600px" style={{ borderRadius: '8px' }} />;
      case "ppt":
      case "docx":
        return <iframe src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedContent.fileUrl)}&embedded=true`} style={{ width: "100%", height: "90vh", border: "none" }} />;
      case "video":
        return <video controls style={{ width: "100%", borderRadius: "8px" }}><source src={selectedContent.fileUrl} type="video/mp4" />Your browser does not support the video tag.</video>;

      case "audio":
        return <audio controls style={{ width: "100%" }}><source src={selectedContent.fileUrl} type="audio/mpeg" /></audio>;

      case "text":
        return <Typography variant="body1" dangerouslySetInnerHTML={{ __html: selectedContent.fileUrl }} sx={{ p: 2, textAlign: "justify" }} />;
      default:
        return <iframe src={`https://www.youtube.com/embed/${extractYouTubeVideoId(selectedContent.fileUrl)}`} style={{ width: "100%", height: "90vh", border: "none" }} allowFullScreen />;

    }
  };

  return (
    <Box sx={{ mt: 3, px: 2 }}>
      <Paper elevation={3} sx={{ maxWidth: "1000px", mx: "auto", p: 3, borderRadius: "12px" }}>

        <Grid item xs={12}>
          <IconButton sx={{ display: { md: 'none' }, position: 'absolute', top: 16, left: 16 }} onClick={() => setDrawerOpen(true)}>
            <MenuIcon />
          </IconButton>
        </Grid>

        <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
          <Box sx={{ width: 250, height: '100vh', p: 2, overflowY: 'auto' }}>
            <IconButton onClick={() => setDrawerOpen(false)} sx={{ mb: 2 }}>
              <CloseIcon />
            </IconButton>
            <CourseList filteredData={filteredData} displayContent={displayContent} />
          </Box>
        </Drawer>

        <Grid item xs={12} md={4}>
          <CourseList filteredData={filteredData} displayContent={displayContent} />

        </Grid>
      </Paper>

      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: "90%", md: "80%" }, bgcolor: 'background.paper', boxShadow: 24, p: 5, borderRadius: "9px" }}>
          <IconButton onClick={() => setModalOpen(false)} sx={{ position: 'absolute', top: 8, right: 8, color: "black", backgroundColor: "white", borderRadius: "50%", p: 0.5 }}>
            <CloseIcon fontSize="large" />
          </IconButton>
          {renderContent()}
        </Box>
      </Modal>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <Button variant="contained" color="error" onClick={() => navigate(-1)} sx={{ px: 3, py: 1.2 }}>Back</Button>
      </Box>
    </Box>
  );
};

const CourseList = ({ filteredData, displayContent }) => (
  <Box >

    <CardContent>
      <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}><FontAwesomeIcon icon={faFilePowerpoint} style={{ marginRight: '8px' }} />Course Content</Typography>
      <List sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {filteredData.map((curriculum) => (
          <ListItem key={curriculum.id} disablePadding sx={{ marginBottom: "10px", width: "220px" }}>
            <ListItemButton
              onClick={() => displayContent(curriculum)}
              sx={{
                width: "100%", // Ensures it takes the full width of ListItem
                maxWidth: "220px", // Controls maximum width
                borderRadius: "12px", // Rounded corners
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: "#DAF7A6", // Light green on hover
                },
              }}
            >
              <ListItemText
                primary={curriculum.sectionName}
                sx={{ textAlign: "center", color: "black", fontWeight: "bold" }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </CardContent>

  </Box>
);

const Managec = () => (
  <div>
    <Header showNotifications={true} />
    <Key />
  </div>
);

export default Managec;
